import { PropertyDecorator, Type } from '../reflection/types';
import { ComponentBase } from './component-base';
import { ComponentData } from './component-data';

export const ChildRef = (selector?: string): PropertyDecorator => {
    return (target: { constructor: Type<ComponentBase<any>> }, propertyKey: string) => {
        ComponentData.registerChildRef(target.constructor, propertyKey, selector);
    };
}